import { createContext, type ReactNode, useContext } from "react";

import { BackofficeAccessDenied } from "../shared/BackofficeAccessDenied";

const BackofficeDutyContext = createContext<readonly string[] | null>(null);

interface BackofficeDutyProviderProps {
  children: ReactNode;
  duties: readonly string[];
}

export function BackofficeDutyProvider({
  children,
  duties,
}: BackofficeDutyProviderProps) {
  return (
    <BackofficeDutyContext.Provider value={duties}>
      {children}
    </BackofficeDutyContext.Provider>
  );
}

export function useHasDuty(duty: string): boolean {
  const duties = useContext(BackofficeDutyContext);
  return duties !== null && duties.includes(duty);
}

interface RequireDutyProps {
  children: ReactNode;
  duty: string;
}

export function RequireDuty({ children, duty }: RequireDutyProps) {
  const duties = useContext(BackofficeDutyContext);

  if (duties === null || !duties.includes(duty)) {
    return <BackofficeAccessDenied duty={duty} />;
  }

  return children;
}
